import CustomCurrencyFormat from 'components/CustomCurrencyFormat';
import React from 'react';
import OrderHistoryList from '../OrderHistoryList';

function OrderHistoryTable({ orders }) {
  const totalOrders = orders?.edges.length;
  return (
    <>
      <div className="table-container">
        <table className="table">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr className="table-header-row">
              <th scope="col" className="table-header">
                Order Number
              </th>
              <th scope="col" className="table-header">
                Date
              </th>
              <th scope="col" className="table-header">
                Total
              </th>
              <th scope="col" className="table-header">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {orders?.edges?.map((item) => {
              const order = item.node;
              return (
                <tr key={order.id} className="table-row">
                  <td className="table-data">{order.orderNumber}</td>
                  <td className="table-data">{order.date || '-'}</td>
                  <td className="table-data">
                    <CustomCurrencyFormat value={order.totalPriceV2.amount} />
                  </td>
                  <td className="table-data">{order.status || '-'}</td>
                  <td className="table-data right">
                    <a className="view-link" href={order.statusUrl}>
                      View
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="list-container">
        <OrderHistoryList orders={orders} />
      </div>
      <div className="paginate">
        1-{totalOrders > 5 ? '5' : totalOrders} of {totalOrders} entries
      </div>
      <style jsx>{`
        .list-container {
          display: none;
        }
        .view-link {
          text-decoration: underline;
          cursor: pointer;

          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: right;
          color: #ffffff;
        }
        .paginate {
          margin-top: 24px;
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: left;
          color: #949494;
          font-family: 'Roboto-Medium';
        }
        .table-header-row {
          text-transform: uppercase;
          white-space: nowrap;
        }
        .table-row {
          width: 100%;
          background: #141414;
          border-radius: 2px;
          border-bottom: #000000 1px solid;
          white-space: nowrap;
        }
        .table-row-unique {
          width: 100%;
          white-space: nowrap;
        }
        .table-row-group {
          width: 100%;
        }
        .table {
          width: 100%;
          text-align: left;
          font-family: 'Roboto-Medium';
          border-collapse: collapse;
        }
        .table-header {
          font-size: 13px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          padding: 16px 24px;
        }
        .table-container {
          width: 100%;
          overflow-x: auto;
          position: relative;
        }
        .table-data {
          font-size: 13px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
          padding: 16px 24px;
        }
        .right {
          text-align: right;
        }
        @media (max-width: 1024px) {
          .table-container {
            display: none;
          }
          .list-container {
            display: block;
          }
        }
        @media (max-width: 991px) {
          .table-container {
            display: block;
          }
          .list-container {
            display: none;
          }
        }
        @media (max-width: 768px) {
          .table-container {
            display: none;
          }
          .list-container {
            display: block;
          }
        }
      `}</style>
    </>
  );
}

export default OrderHistoryTable;
